import FormPropertiesProvider from './FormPropertiesProvider'

export default {
  __init__: ['formPropertiesProvider'],
  formPropertiesProvider: ['type', FormPropertiesProvider],
}
